import { useCallback, useMemo } from "react"

import { useSearch, useLocation } from "wouter"

import { STEP_SEARCH_PARAM_NAME } from "@/config"

import { parseStepParam } from "../../schemas/urlParamSchemas"

const useStepParam = () => {
  const search = useSearch()
  const [location, navigate] = useLocation()

  const step = useMemo(() => {
    const params = new URLSearchParams(search)
    const rawStep = params.get(STEP_SEARCH_PARAM_NAME)
    return parseStepParam(rawStep)
  }, [search])

  const goToDetails = useCallback(() => {
    const params = new URLSearchParams(search)
    params.set(STEP_SEARCH_PARAM_NAME, "details")
    // Keep current path, only modify query params
    navigate(`${location}?${params.toString()}`)
  }, [search, location, navigate])

  const goBackToSearch = useCallback(() => {
    const params = new URLSearchParams(search)
    params.delete(STEP_SEARCH_PARAM_NAME)
    const query = params.toString()
    // Keep current path, only modify query params
    navigate(query ? `${location}?${query}` : location)
  }, [search, location, navigate])

  return { step, goToDetails, goBackToSearch }
}

export default useStepParam
